<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div v-if="role === 'SuperAdministrador'">
                <AccessibleElSelect
                  v-model="form.distribuidor.value"
                  prop="distribuidor"
                  :options="distribuidoresForAccessibleSelect"
                  :withFormItem="true"
                  @select="handleSelectDistribuidor"
                  id-prefix="maestrodocumentosfilter"
                >
                  <template slot="label">{{$t('distributors.distributor')}}</template>
                </AccessibleElSelect>
              </div>

              <AccessibleElSelect
                v-model="form.empresa.value"
                prop="empresa"
                :options="clientesForAccessibleSelect"
                :withFormItem="true"
                @select="handleSelectCliente"
                id-prefix="maestrodocumentosfilter"
              >
                <template slot="label">{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('documentmaster.Documento')}}
                <el-form-item prop="Documento">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Documento.value"
                    maxlength="255"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('documentmaster.Extension')}}
                <el-form-item prop="Extension">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Extension.value"
                    maxlength="50"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('documentmaster.CodigoTipoDocumento')}}
                <el-form-item prop="CodigoTipoDocumento">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.CodigoTipoDocumento.value"
                    maxlength="10"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('documentmaster.DescripcionTipoDocumento')}}
                <el-form-item prop="DescripcionTipoDocumento">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.DescripcionTipoDocumento.value"
                    maxlength="500"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('documentmaster.CIF')}}
                <el-form-item prop="CIF">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.cif.value"
                    maxlength="50"
                  />
                </el-form-item>
              </label>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    distribuidoresForAccessibleSelect: function () {
      return this.distribuidores.map(item => ({
        id: item.IdDistribuidor,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    clientesForAccessibleSelect: function () {
      return this.clientes.map(item => ({
        id: item.IdEmpresa,
        name: item.Nombre,
        value: item.Nombre
      }))
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'documentmaster',
      isOpen: this.panelOpen,
      form: {
        Documento: { label: i18n.t('documentmaster.Documento'), value: '' },
        Extension: { label: i18n.t('documentmaster.Extension'), value: '' },
        CodigoTipoDocumento: { label: i18n.t('documentmaster.CodigoTipoDocumento'), value: '' },
        DescripcionTipoDocumento: { label: i18n.t('documentmaster.DescripcionTipoDocumento'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        cif: { label: i18n.t('app.company'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()

        this.form.Documento.value = _temp.Documento !== undefined && _temp.Documento.value !== '' ? _temp.Documento.value : ''
        this.form.Extension.value = _temp.Extension !== undefined && _temp.Extension.value !== '' ? _temp.Extension.value : ''
        this.form.CodigoTipoDocumento.value = _temp.CodigoTipoDocumento !== undefined && _temp.CodigoTipoDocumento.value !== '' ? _temp.CodigoTipoDocumento.value : ''
        this.form.DescripcionTipoDocumento.value = _temp.DescripcionTipoDocumento !== undefined && _temp.DescripcionTipoDocumento.value !== '' ? _temp.DescripcionTipoDocumento.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.cif.value = _temp.cif !== undefined && _temp.cif.value !== '' ? _temp.cif.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        Documento: { label: i18n.t('documentmaster.Documento'), value: '' },
        Extension: { label: i18n.t('documentmaster.Extension'), value: '' },
        CodigoTipoDocumento: { label: i18n.t('documentmaster.CodigoTipoDocumento'), value: '' },
        DescripcionTipoDocumento: { label: i18n.t('documentmaster.DescripcionTipoDocumento'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        cif: { label: i18n.t('app.company'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
  }
}
</script>
